export default {
    acceptCookies() {
        this.$store.commit('acceptCookies')
    }
}
